// BM-H4109, 9 October 2026. Which matter a Call note opened from the top
// bar belongs to.
//
// The top bar "Call note" button sends no matter, so GlobalCallNote in App.js
// guessed one from the URL. It only looked at /submission/, /detail/ and
// /open-matter/ paths whose last part contains a dot. The matter page is
// /matter/BL.X.000.0000 and a FORF page is /submission/<id>, so on both the
// note opened with no matter, was saved as "not case-related", and never
// reached the matter's FileSnap.
//
// Pages that know their matter now register it here while they are open,
// and the URL guess also understands /matter/<ref>.

let currentMatterRef = "";

export function setCurrentMatterRef(ref) {
  currentMatterRef = (ref || "").trim();
}

export function clearCurrentMatterRef(ref) {
  // Only clear our own registration, so a page unmounting after the next
  // page has mounted cannot wipe the newer page's matter.
  if (!ref || (ref || "").trim() === currentMatterRef) currentMatterRef = "";
}

export function getCurrentMatterRef() {
  return currentMatterRef;
}

const REF_PATH_PREFIXES = ["matter", "submission", "submissions", "detail", "open-matter"];

function looksLikeRef(s) {
  return !!s && s.includes(".") && s.length > 5;
}

// Explicit ref from the event wins, then ?matter_ref=, then a ref in the
// path, then whatever the open page registered.
export function resolveCallNoteMatterRef({ override, pathname, search, registered }) {
  if (override) return override;
  try {
    const params = new URLSearchParams(search || "");
    const q = params.get("matter_ref");
    if (q) return q;
    const parts = (pathname || "").split("/").filter(Boolean);
    if (parts.length >= 2 && REF_PATH_PREFIXES.includes(parts[0])) {
      const candidate = decodeURIComponent(parts[1]);
      if (looksLikeRef(candidate)) return candidate;
    }
  } catch {
    // fall through to the registered matter
  }
  return registered || "";
}
